import React from 'react'
import { Route } from 'react-router-dom'

import OccupationComparison from './OccupationComparison'
import OccupationProfile from './OccupationProfile'
import VideoListing from './VideoListing'
import OccupationListing from './OccupationListing'

function OccupationRoutes(props) {
  return (
    <>
      <Route path="/occupation/:occId" component={OccupationProfile} />
      <Route path="/occupations/list" component={OccupationListing} />

      <Route path="/occupations/comparison" component={OccupationComparison} />
      <Route path="/videos" component={VideoListing} />
    </>
  )
}

OccupationRoutes.propTypes = {}
OccupationRoutes.defaultProps = {}

export default OccupationRoutes
